import dayjs from 'dayjs';

export const planFeatures = [
  {
    name: 'Free',
    productId: '',
    features: [
      {
        feature: 'All features free for 7 days',
        title: true,
      },
    ],
  },
  {
    name: 'Pro',
    productId: 'prod_O5glFnR5imW3Q2',
    features: [
      {
        feature: 'Jobs',
        title: true,
      },
      {
        feature: 'Unlimited Job Postings',
        title: false,
      },
      {
        feature: 'Manage Premium Job Postings on Job Boards',
        title: false,
      },
      {
        feature: 'Convert Jobs into PDF Documents',
        title: false,
      },
      {
        feature: 'JD Parsing ',
        title: false,
      },

      {
        feature: 'Job Posting on Free Job Boards',
        title: false,
      },

      {
        feature: 'Candidates',
        title: true,
      },
      {
        feature: 'Candidate Rapid Sourcing Browser Extension',
        title: false,
      },
      {
        feature: 'Candidate Search on 10 + Premium Resume Databases ',
        title: false,
      },
      {
        feature: 'Manage Resume Views Quota on Premium Job Boards',
        title: false,
      },
      {
        feature: 'Import Candidates from Excel',
        title: false,
      },
      {
        feature: 'Import Candidate from Local Computer ',
        title: false,
      },
      {
        feature: 'Import Candidates from G Drive',
        title: false,
      },
      {
        feature: 'Bulk Submission of Candidates ',
        title: false,
      },
      {
        feature: 'Candidate Email Campaigns',
        title: false,
      },
      {
        feature: 'Custom Submission Email Templates',
        title: false,
      },
      {
        feature: 'Candidate Follow up Notifications',
        title: false,
      },
      {
        feature: 'Active Consultants - Ready to Join',
        title: false,
      },
      {
        feature: 'AI and Automation',
        title: true,
      },
      {
        feature: 'Automated Candidate Database Building',
        title: false,
      },

      {
        feature: 'Resume Parsing Credits ',
        title: false,
      },
      {
        feature: 'Resume Parsing by Email ',
        title: false,
      },
      {
        feature: 'Resume Harvesting Bots ',
        title: false,
      },

      {
        feature: 'VMS Integation ',
        title: true,
      },
      {
        feature: 'VMS Integrations ',
        title: false,
      },
      {
        feature: 'Real Time Syncing of Jobs',
        title: false,
      },

      {
        feature: 'Talent Bench',
        title: true,
      },
      {
        feature: 'Upload Unlimited Consultants',
        title: false,
      },
      {
        feature: 'Upload Consultants from Excel',
        title: false,
      },
      {
        feature: 'Mass Mail Campaigns -  Add On',
        title: false,
      },
      {
        feature: 'Daily New Vendor List Matching Talent Bench',
        title: false,
      },
      {
        feature: 'Contact List Cleaning Credits - Add On',
        title: false,
      },
      {
        feature: 'Communication ',
        title: true,
      },
      {
        feature: 'Email Inbox ',
        title: false,
      },
      {
        feature: 'SMS Credits - Add On',
        title: false,
      },
      {
        feature: 'SMS Inbox',
        title: false,
      },
      {
        feature: 'Google and Outlook Calendar Integrations',
        title: false,
      },
      {
        feature: 'Email Templates for Candidate Communication ',
        title: false,
      },
      {
        feature: 'Google Meet Integration (Coming Soon) ',
        title: false,
      },
      {
        feature: 'MS Teams Integration (Coming Soon)',
        title: false,
      },
      {
        feature: 'Configure Unlimited Email Accounts for sending',
        title: false,
      },
      {
        feature: 'Analytics',
        title: true,
      },
      {
        feature: 'Real-Time Analytics',
        title: false,
      },
      {
        feature: '100+ Visualizations and Tables',
        title: false,
      },
      {
        feature: 'Career Pages ',
        title: true,
      },
      {
        feature: 'Branded Career Portal ',
        title: false,
      },
      {
        feature: 'Embedded on your domain ',
        title: false,
      },
      {
        feature: 'Security ',
        title: true,
      },
      {
        feature: '2 Factor Authentcation ',
        title: false,
      },
      {
        feature: 'User Management',
        title: false,
      },
      {
        feature: 'Customised Access Control - Coming soon',
        title: false,
      },
      {
        feature: 'Customisation and Support ',
        title: true,
      },
      {
        feature: 'Custom Submission Status',
        title: false,
      },
      {
        feature: 'Custom Job Fields',
        title: false,
      },
      {
        feature: 'Customisable Email Templates',
        title: false,
      },
      {
        feature: 'Initial Implementation -  10 Hours',
        title: false,
      },
      {
        feature: 'Training and On boarding - 20 Hours ',
        title: false,
      },
      {
        feature: 'Email Support ',
        title: false,
      },
      {
        feature: 'Data Migration -  10000  Profiles',
        title: false,
      },
    ],
  },
  {
    name: 'Enterprise',
    productId: 'prod_O5grJ1xwYuOT5e',
    features: [
      {
        feature: 'All Pro Plan features along with',
        title: true,
        custom: true,
      },
      {
        feature: 'Jobs',
        title: true,
      },
      {
        feature: 'Favorite Jobs',
        title: false,
      },
      {
        feature: 'Custom Job Fields',
        title: false,
      },
      {
        feature: 'AI and Automation',
        title: true,
      },
      {
        feature: 'AI Similar Jobs',
        title: false,
      },
      {
        feature: 'AI Candidate Matching',
        title: false,
      },
      {
        feature: 'VMS Integration',
        title: true,
      },
      {
        feature: 'Custom integration with other VMS',
        title: false,
      },
      {
        feature: 'Customisation and Support',
        title: true,
      },
      {
        feature: 'Custom Submission Status',
        title: false,
      },
      {
        feature: 'Custom Job Fields',
        title: false,
      },
    ],
  },
];

export const getPlanRate = (feature: string, mandateTime: number) => {
  let rate = '';
  if (mandateTime === 0) {
    switch (feature) {
      case 'Pro':
        rate = '$25';
        break;
      case 'Enterprise':
        rate = '$50';
        break;
    }
  } else if (mandateTime === 1) {
    switch (feature) {
      case 'Pro':
        rate = '$22.5';
        break;
      case 'Enterprise':
        rate = '$45';
        break;
    }
  } else if (mandateTime === 2) {
    switch (feature) {
      case 'Pro':
        rate = '$20';
        break;
      case 'Enterprise':
        rate = '$40';
        break;
    }
  }
  return rate;
};

export const getPlanRateByInterval = (feature: string, mandateTime: string) => {
  let rate = 0;
  if (mandateTime === 'month') {
    switch (feature) {
      case 'Pro':
        rate = 25;
        break;
      case 'Enterprise':
        rate = 50;
        break;
    }
  } else if (mandateTime === 'quater') {
    switch (feature) {
      case 'Pro':
        rate = 22.5;
        break;
      case 'Enterprise':
        rate = 45;
        break;
    }
  } else if (mandateTime === 'annual') {
    switch (feature) {
      case 'Pro':
        rate = 20;
        break;
      case 'Enterprise':
        rate = 40;
        break;
    }
  }
  return rate;
};

export const getRazorPlanRateByInterval = (feature: string, mandateTime: string) => {
  let rate = 0;
  if (mandateTime === 'month') {
    switch (feature) {
      case 'Pro':
        rate = 2054.37;
        break;
      case 'Enterprise':
        rate = 4108.67;
        break;
    }
  } else if (mandateTime === 'quater') {
    switch (feature) {
      case 'Pro':
        rate = 5546.4;
        break;
      case 'Enterprise':
        rate = 11093.42;
        break;
    }
  } else if (mandateTime === 'annual') {
    switch (feature) {
      case 'Pro':
        rate = 19720.67;
        break;
      case 'Enterprise':
        rate = 39443.74;
        break;
    }
  }
  return rate;
};

export const getPlanCode = (plan: string) => {
  let code: string | null = null;
  switch (plan) {
    case 'Standard':
      code = 'STD';
      break;
    case 'Premium':
      code = 'PRM';
      break;
    case 'Enterprise':
      code = 'ENT';
      break;
    case 'Pro':
      code = 'PRO';
      break;
  }
  return code;
};

export const getPlanFromPlanCode = (planCode?: string | null) => {
  let plan: string | null = 'Undefined';
  switch (planCode) {
    case 'TRIAL':
      plan = 'Free';
      break;
    case 'STD':
      plan = 'Standard';
      break;
    case 'PRM':
      plan = 'Premium';
      break;
    case 'ENT':
      plan = 'Enterprise';
      break;
    case 'PRO':
      plan = 'Pro';
      break;
  }
  return plan;
};

export const getIntervalFromSKU = (
  startDate: string | null | undefined,
  endDate: string | null | undefined
) => {
  let interval = 'none';
  if (startDate && endDate) {
    const diffInMonth = dayjs(dayjs(endDate).format('MM/DD/YYYY')).diff(
      dayjs(dayjs(startDate).format('MM/DD/YYYY')),
      'month'
    );
    if (diffInMonth === 1) {
      interval = 'month';
    } else if (diffInMonth === 3) {
      interval = 'quater';
    } else if (diffInMonth === 12) {
      interval = 'annual';
    }
  }

  return interval;
};

export const getRazorPayProductId = (feature: string, mandateTime: string) => {
  let productId = '';
  if (mandateTime === 'month') {
    switch (feature) {
      case 'Pro':
        productId = 'plan_MIsvre6wRdGozI';
        break;
      case 'Enterprise':
        productId = 'plan_MIt16cyGVsiEYP';
        break;
    }
  } else if (mandateTime === 'quater') {
    switch (feature) {
      case 'Pro':
        productId = 'plan_MIsypSmAIKLu1O';
        break;
      case 'Enterprise':
        productId = 'plan_MIt1qi4g6fapUH';
        break;
    }
  } else if (mandateTime === 'annual') {
    switch (feature) {
      case 'Pro':
        productId = 'plan_MIt0J29IN1CHKk';
        break;
      case 'Enterprise':
        productId = 'plan_MIt2WB2iyPCpfq';
        break;
    }
  }
  return productId;
};

export const getNoOfMonthFromInterval = (interval: string) => {
  if (interval) {
    switch (interval) {
      case 'month':
        return 1;
      case 'quater':
        return 3;
      case 'annual':
        return 12;
    }
  }
  return 1;
};
